/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import ListTitleIcon from '../../images/lecturerInvite/list-title-q.png'

class ListTitle extends React.Component {

    constructor() {
        super();
        this.handleNowClick = this.handleNowClick.bind(this);
        this.handleHistoryClick = this.handleHistoryClick.bind(this);
    }

    handleNowClick() {
        this.context.page.showAlert('当前嘉宾', '', '温馨提示');
    }

    handleHistoryClick() {
        this.context.page.showAlert('历史嘉宾', '', '温馨提示');
    }


    render() {
        const {title, type} = this.props;
        return (
            <div className="lecturer-invite-listtitle">
                <div className="listtitle-main">
                    <div className="main-text">
                        {title}
                    </div>
                    <div className="main-icon" onClick={type === 'now' ? this.handleNowClick : this.handleHistoryClick}>
                        <img src={ListTitleIcon} alt=""/>
                    </div>
                </div>
            </div>
        )
    }
}

ListTitle.contextTypes = {
    page: React.PropTypes.object,
};

export default ListTitle


// WEBPACK FOOTER //
// ./src/components/lecturerInvite/ListTitle.js